import { creatorbase } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { CellContext } from '@tanstack/react-table';
import { ProjectTableMeta } from '../../../components/types';

export type ProjectsTableRow = creatorbase.Project & {
    brand: creatorbase.Brand | null;
    team: creatorbase.Team | null;
    partnership: creatorbase.Partnership | null;
    users: creatorbase.User[];
    songStatsTimeSeries:
        | creatorbase.TimeSeriesResponse<'tiktok_daily_change' | 'instagram_daily_change'>[number]
        | null;
};

export type Meta = ProjectTableMeta<ProjectsTableRow> & {
    isLoading?: boolean;
    hasError?: boolean;
    onSongChartClick: (songId: number) => void;
    onDeleteProject: (project: ProjectsTableRow) => void;
    isPartnershipLoading?: (row: ProjectsTableRow | {}) => boolean;
};

export type TableCellContext<TKey extends keyof ProjectsTableRow> = CellContext<
    ProjectsTableRow,
    ProjectsTableRow[TKey]
>;

export const getTableMeta = getTableMetaHelper<Meta>();
export const resolveRowId = (row: ProjectsTableRow | {}) => ('id' in row && typeof row.id === 'number' ? row.id : null);
